import type { TReaderDocument } from '@app-evolution-cms/email-builder';

import { NEW_BLOCKS } from '../constants/blocks';

type ContainerBlock = Extract<TReaderDocument[string], { type: 'Container' }>;

export function normalizeBlockDocument(
  document: TReaderDocument,
  rootBlockId: string,
): TReaderDocument {
  const rootBlock = document[rootBlockId];

  if (!rootBlock || rootBlock.type !== 'EmailLayout') {
    return document;
  }

  const rootChildrenIds = rootBlock.data.childrenIds ?? [];
  const firstChildId = rootChildrenIds[0];
  const firstChild = firstChildId ? document[firstChildId] : undefined;

  if (firstChild?.type === 'Container' && rootChildrenIds.length === 1) {
    return document;
  }

  if (firstChild?.type === 'Container') {
    return {
      ...document,
      [rootBlockId]: {
        ...rootBlock,
        data: {
          ...rootBlock.data,
          childrenIds: [firstChildId],
        },
      },
      [firstChildId]: {
        ...firstChild,
        data: {
          ...firstChild.data,
          props: {
            ...(firstChild.data.props ?? {}),
            childrenIds: [
              ...(firstChild.data.props?.childrenIds ?? []),
              ...rootChildrenIds.slice(1),
            ],
          },
        },
      },
    };
  }

  let containerId = `${rootBlockId}-container`;
  let suffix = 1;

  while (document[containerId]) {
    containerId = `${rootBlockId}-container-${suffix}`;
    suffix += 1;
  }

  const container = structuredClone(NEW_BLOCKS.container) as ContainerBlock;
  container.data.props = {
    ...(container.data.props ?? {}),
    childrenIds: rootChildrenIds,
  };

  return {
    ...document,
    [rootBlockId]: {
      ...rootBlock,
      data: {
        ...rootBlock.data,
        childrenIds: [containerId],
      },
    },
    [containerId]: container,
  };
}
